import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a0447a92")

_pushScopeId("data-v-a0447a92")
const _hoisted_1 = { class: "select-language" }
const _hoisted_2 = { for: "locale" }
const _hoisted_3 = { value: "en" }
const _hoisted_4 = { value: "ko" }
const _hoisted_5 = { value: "uz" }
const _hoisted_6 = { value: "ru" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.t("language")), 1),
    _withDirectives(_createVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.locale = $event))
    }, [
      _createVNode("option", _hoisted_3, _toDisplayString(_ctx.t("en")), 1),
      _createVNode("option", _hoisted_4, _toDisplayString(_ctx.t("ko")), 1),
      _createVNode("option", _hoisted_5, _toDisplayString(_ctx.t("uz")), 1),
      _createVNode("option", _hoisted_6, _toDisplayString(_ctx.t("ru")), 1)
    ], 512), [
      [_vModelSelect, _ctx.state.locale]
    ])
  ]))
})